export default function(state={ data: [] }, action) {
	switch(action.type) {
		case 'NOTES_GET_REQUEST':

			return {
				...state,
				data: [],
			}
		case 'NOTES_GET_SUCCESS':
			const { docs } = action.result;
			return {
				...state,
				data: docs,
			}
		case 'NOTE_CREATE_SUCCESS':
			// console.log(state.data);
			state.data.unshift(action.result);
			return state;
		case 'NOTE_UPDATE_SUCCESS':
			let i = state.data.findIndex(x => x._id === action.result._id);
			if(~i) state.data[i] = action.result;
			return state;
		case 'NOTE_DELETE_SUCCESS':
			state.data = state.data.filter(x => x._id !== action.result._id);
			return state;
		default:
			return state;
	}

}


// WEBPACK FOOTER //
// ./src/modules/note/note.reducer.js